import OktaAuth from "@okta/okta-auth-js";
import { jwtDecode } from "jwt-decode";
import { oktaConfig } from "./oktaConfig";


const oktaAuth = new OktaAuth(oktaConfig);

const isTokenExpired = (token: any) => {
    if (!token || token === 'undefined') {
        return true;
    }

    const { exp } = jwtDecode(token);

    const currentTime = Date.now() / 1000;

    return exp && exp < currentTime;
}

const generateNewToken = async () => {
    try {
        const authTokens = await oktaAuth.token.getWithoutPrompt({
            responseType: ['id_token', 'token'],
            scopes: oktaConfig.scopes,
            prompt: 'none'
        });

        oktaAuth.tokenManager.setTokens(authTokens.tokens);
        console.log("Token renewed behind the scene", authTokens);
        
        return authTokens?.tokens?.accessToken?.accessToken;
    } catch (err) {
        console.log("Token failed to renewed", err);
        oktaAuth.signInWithRedirect();
    }
}

export { oktaAuth, isTokenExpired, generateNewToken }